import React from 'react';

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-2xl font-semibold text-[#1a3a5c]">{title}</h2>
    <div className="space-y-3 text-slate-700 leading-relaxed">{children}</div>
  </section>
);

export default function PrivacyPolicyPage() {
  return (
    <div className="bg-slate-50 py-16">
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 bg-white rounded-2xl shadow-sm p-8 md:p-12 space-y-10">
        <header className="space-y-3">
          <p className="text-sm font-semibold uppercase tracking-wide text-[#0077b6]">Protection des renseignements personnels</p>
          <h1 className="text-4xl font-bold text-[#1a3a5c]">Politique de confidentialité</h1>
          <p className="text-slate-600">Dernière mise à jour : 17 septembre 2026</p>
        </header>

        <Section title="Responsable de la protection des renseignements personnels">
          <p>Éric Lebleu est responsable de la protection des renseignements personnels chez Le Bleu des Champs.</p>
          <p>Pour toute question, demande d’accès, de rectification ou plainte, écrivez à <a className="text-[#0077b6] underline" href="mailto:lebleudeschamps@bellnet.ca">lebleudeschamps@bellnet.ca</a> ou téléphonez au <a className="text-[#0077b6] underline" href="tel:+14504693483">(450) 469-3483</a>.</p>
        </Section>

        <Section title="Renseignements recueillis">
          <p>Selon le formulaire utilisé, nous pouvons recueillir les renseignements que vous transmettez volontairement, notamment votre nom, vos coordonnées, votre adresse, les renseignements sur votre projet, votre appareil ou le service demandé, ainsi que les documents que vous choisissez de joindre.</p>
        </Section>

        <Section title="Utilisation et consentement">
          <p>Ces renseignements servent à répondre à votre demande, préparer une soumission, planifier ou exécuter un service, communiquer avec vous, assurer le suivi administratif et respecter nos obligations légales.</p>
          <p>En transmettant un formulaire, vous consentez à l’utilisation des renseignements nécessaires au traitement de cette demande. Vous pouvez retirer votre consentement, sous réserve des obligations légales et contractuelles applicables.</p>
        </Section>

        <Section title="Communication, hébergement et mesures de protection">
          <p>Le Bleu des Champs applique des mesures administratives et techniques visant à limiter l’accès aux personnes et fournisseurs qui en ont besoin pour accomplir leurs fonctions.</p>
          <p>Certains fournisseurs technologiques peuvent traiter des renseignements à l’extérieur du Québec ou du Canada. Vous pouvez communiquer avec le responsable pour obtenir davantage d’information sur ces fournisseurs et les territoires concernés.</p>
        </Section>

        <Section title="Conservation et destruction">
          <p>La durée de conservation dépend de la nature de la demande, de la relation avec le client et des obligations légales applicables. Une demande concernant la conservation ou la suppression de vos renseignements peut être adressée au responsable.</p>
        </Section>

        <Section title="Vos droits">
          <p>Vous pouvez demander l’accès à vos renseignements, leur rectification ou, lorsque la loi le permet, le retrait de votre consentement. Nous pouvons devoir vérifier votre identité avant de répondre.</p>
        </Section>

        <Section title="Témoins et mesures d’audience">
          <p>Le site utilise les mécanismes techniques nécessaires à son fonctionnement. Aucun outil d’enregistrement de session ni outil publicitaire n’est activé sans mécanisme de consentement approprié.</p>
        </Section>

        <Section title="Mise à jour de la politique">
          <p>Cette politique peut être modifiée pour refléter l’évolution de nos pratiques ou des exigences applicables. La date de mise à jour indique la version en vigueur.</p>
        </Section>
      </article>
    </div>
  );
}
